import { css } from 'styled-components';
import { ErrorBoundariesProps } from './models';

export const ErrorBoundary = css<ErrorBoundariesProps>(({ theme }) => {
  return css`
    width: 100%;
    height: 100%;
  `;
});
